var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"main-app"},[_c('div',{staticClass:"main-content"},[_c('EventsComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }